/*
 * Public API Surface of kraken-tabs
 */

export * from './lib/kraken-tabs.service';
export * from './lib/kraken-tabs.component';
export * from './lib/kraken-tabs.module';
export * from './lib/kraken-tab/kraken-tab.component'

